import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW7200Model } from './kymw7200.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { CodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { GetOperationGoodsListService } from './api-services/get-operation-goods-list.service';
import { DeleteOperationGoodsService } from './api-services/delete-operation-goods.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { SearchOperationGoodsListModel } from './vo/search-operation-goods-list.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CellType, FlexGrid, CellRange } from '@grapecity/wijmo.grid';
import { Menu } from '@grapecity/wijmo.input';

/**
 * 運営商品一覧画面を管理するクラス
 *
 * @export KYMW7200Component
 * @class KYMW7200Component
 */
@Component({
  selector: 'app-kymw7200',
  templateUrl: 'kymw7200.component.html',
  styleUrls: ['kymw7200.component.scss'],
  providers: [
    GetOperationGoodsListService,
    DeleteOperationGoodsService
  ],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7200Component extends PlessViewHelperSub implements OnInit {

  public kymw7200Model: KYMW7200Model = new KYMW7200Model();
  // VO設定
  public vo: SearchOperationGoodsListModel = new SearchOperationGoodsListModel();

  @ViewChild('rbtn_Weekly', { static: true }) rbtn_Weekly: RadioLabelComponent;
  @ViewChild('rbtn_Daily', { static: true }) rbtn_Daily: RadioLabelComponent;
  @ViewChild('cmb_DepositCapitalIncreasePattern', { static: true }) cmb_DepositCapitalIncreasePattern: CodeComboBoxComponent;
  @ViewChild('dtg_OperationGoodsList', { static: true }) dtg_OperationGoodsList: FlexGrid;
  @ViewChild('cmb_PlanningManagementDetailDiv', { static: true }) cmb_PlanningManagementDetailDiv: CodeComboBoxComponent;
  @ViewChild('btn_NewAdd', { static: true }) btn_NewAdd: ElementRef;
  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;

  // コンテキストメニュー(右クリック)
  private contextMenu: Menu;
  
  // 検索済かをチェックするパラメータ
  private searchFlg: boolean = false;

  /**
   *Creates an instance of KYMW7200Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @param {CatalogLockService} catalogLockServiceSub
   * @param {GetCatalogProgressOfMediumService} getCatalogProgressOfMediumService
   * @param {GetOrderNumListService} getOrderNumListService
   * @param {UpdateIndiscriminatelyOrderNumService} updateIndiscriminatelyOrderNumService
   * @param {UpdateIndividuallyOrderNumService} updateIndividuallyOrderNumService
   * @param {ElementRef} elementRef
   * @param {PlessHttp} plessHttp
   * @memberof KYMW7200Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getOperationGoodsListService: GetOperationGoodsListService,
    private router: Router,
    private deleteOperationGoodsListService: DeleteOperationGoodsService,
    private elementRef: ElementRef,
    private route: ActivatedRoute,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW7200Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7200';
    this.kymw7200Model.kymw7200Component = this;
    this.setContextMenu();
    this.dtg_OperationGoodsList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_OperationGoodsList.hitTest(e);
      if (0 <= ht.row && !ht.target.className.includes('wj-header')) {
        switch (ht.col) {
          case 0:
            document.getElementById(`TargetFlg_${ht.row}`).click();
            break;
        }
      }
    });

    this.route.queryParams.subscribe((params) => {
      // 運営商品登録画面で保持していた検索条件取得
      if ('searchDeliveryDiv' in params) {
        this.kymw7200Model.deliveryDiv = params['searchDeliveryDiv'];
      } else {
        this.kymw7200Model.deliveryDiv = '1';
      }
      if ('searchOrderNum' in params) {
        this.kymw7200Model.orderNum = params['searchOrderNum'];
      }
      if ('searchPlanningManagementDiv' in params) {
        this.kymw7200Model.planningManagementDiv = params['searchPlanningManagementDiv'];
        this.cmb_planningManagementDiv_CHANGEHandler();
      }
      if ('searchGoodsName' in params) {
        this.kymw7200Model.goodsName = params['searchGoodsName'];
      }
      if ('searchOrderCatalog' in params) {
        this.kymw7200Model.orderCatalog = params['searchOrderCatalog'];
      }
      if ('searchPlanningManagementDetailDiv' in params) {
        this.kymw7200Model.planningManagementDetailDiv = params['searchPlanningManagementDetailDiv'];
      }
      if ('searchStandardName' in params) {
        this.kymw7200Model.standardName = params['searchStandardName'];
      }

      // 遷移前に検索していた場合再検索
      for (const key of Object.keys(params)) {
        if(params[key]) {
          this.eventSearchOperationGoods_CLICKHandler();
          break;
        }
      }
    });
  }

  /**
   * 検索ボタンイベント
   *
   * @memberof KYMW7200Component
   */
  public eventSearchOperationGoods_CLICKHandler(): void {

    // 検索時はページ番号を1に初期化する
    this.kymw7200Model.page = '1';
    /** 宅配業態. */
    this.vo.deliveryDiv = this.kymw7200Model.deliveryDiv;
    /** 注文コード */
    this.vo.orderNum = this.kymw7200Model.orderNum;
    /** 受注企画回*/
    this.vo.orderCatalog = this.kymw7200Model.orderCatalog;
    /** 運営企画区分. */
    this.vo.planningManagementDiv = this.kymw7200Model.planningManagementDiv;
    /** 運営企画詳細区分. */
    this.vo.planningManagementDetailDiv = this.kymw7200Model.planningManagementDetailDiv;
    /** 商品名. */
    this.vo.goodsName = this.kymw7200Model.goodsName;
    /** 規格名. */
    this.vo.standardName = this.kymw7200Model.standardName;
    // ページ
    this.vo.page = this.kymw7200Model.page;

    // 共通必須項目チェック
    if (!this.requiredCheck(this.vo)) {
      return;
    }

    // データ取得
    this.getOperationGoodsListService.execute(this.kymw7200Model, this.vo, () => {
      // データの取得件数が500件以上の場合
      if (this.kymw7200Model.totalNum > 500) {
        // "取得件数が{0}件を超えています。再度条件を設定し、検索してください。"
        this.dialogServiceSub.openAlertGetMessage('E0524', ['500']);
      } else if (this.kymw7200Model.totalNum === 0) {
        // 検索結果が0件です
        this.dialogServiceSub.openAlertGetMessage('W0049');
      }
    });

    // 検索済に変更
    this.searchFlg = true;
    // 検索条件の保持
    this.kymw7200Model.searchDeliveryDiv = this.vo.deliveryDiv;
    this.kymw7200Model.searchOrderNum = this.vo.orderNum;
    this.kymw7200Model.searchPlanningManagementDiv = this.vo.planningManagementDiv;
    this.kymw7200Model.searchGoodsName = this.vo.goodsName;
    this.kymw7200Model.searchOrderCatalog = this.vo.orderCatalog;
    this.kymw7200Model.searchPlanningManagementDetailDiv = this.vo.planningManagementDetailDiv;
    this.kymw7200Model.searchStandardName = this.vo.standardName;
  }

  /**
   * 必須項目チェック
   *
   * @private
   * @param {SearchOperationGoodsListModel} vo サーバへのリクエストデータ
   * @returns {Boolean}
   * @memberof KYMW7200Component
   */
  private requiredCheck(vo: SearchOperationGoodsListModel): boolean {

    if (PlessViewUtilsSub.isEmpty(vo.deliveryDiv)) {
      this.dialogServiceSub.openAlertGetMessage('E0110', ['宅配業態']);
      return false;
    }
    if (!PlessViewUtilsSub.isEmpty(vo.orderNum)) {
      if (vo.orderNum.length !== 6) {
        // 注文コード桁数チェック
        this.dialogServiceSub.openAlertGetMessage('W0005', ['注文コード', '6']);
        return false;
      }
    }
    if (!PlessViewUtilsSub.isEmpty(vo.orderCatalog)) {
      if (vo.orderCatalog.length !== 8) {
        // 受注企画回桁数チェック
        this.dialogServiceSub.openAlertGetMessage('W0005', ['受注企画回', '8']);
        return false;
      }
    }
    if (!PlessViewUtilsSub.isEmpty(vo.planningManagementDiv)) {
      if (vo.planningManagementDiv.length !== 2) {
        this.dialogServiceSub.openAlertGetMessage('W0005', ['運営企画区分', '2']);
        return false;
      }
    }
    if (!PlessViewUtilsSub.isEmpty(vo.planningManagementDetailDiv)) {
      if (vo.planningManagementDetailDiv.length !== 4) {
        this.dialogServiceSub.openAlertGetMessage('W0005', ['運営企画詳細区分', '4']);
        return false;
      }
    }
    if (!this.isNotOverMaxLength(vo.goodsName, 30)) {
      // 商品名桁数チェック
      this.dialogServiceSub.openAlertGetMessage('W0007', ['商品名', '30']);
      return false;
    }
    if (!this.isNotOverMaxLength(vo.standardName, 20)) {
      // 規格名桁数チェック
      this.dialogServiceSub.openAlertGetMessage('W0007', ['規格名', '20']);
      return false;
    }
    return true;
  }

  /**
   * 文字列の桁数チェック
   * @param value : 対象文字列
   * @param value : 最大桁数
   * @return true : 桁数正常
   *         false : 桁数オーバー
   */
  public isNotOverMaxLength(value: string, num: number): boolean {
    let result: boolean = <boolean>true;

    if (!PlessViewUtilsSub.isEmpty(value)) {
      if (value.length > num) {
        result = false;
      }
    }
    return result;
  }

  /**
   * 「前へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventPrev_CLICKHandler(): void {
    // ページ番号をディクリメント(-1)
    this.kymw7200Model.page = (parseInt(this.kymw7200Model.page) - 1).toString();

    /** 宅配業態. */
    this.vo.deliveryDiv = this.kymw7200Model.deliveryDiv;
    /** 注文コード */
    this.vo.orderNum = this.kymw7200Model.orderNum;
    /** 受注企画回*/
    this.vo.orderCatalog = this.kymw7200Model.orderCatalog;
    /** 運営企画区分. */
    this.vo.planningManagementDiv = this.kymw7200Model.planningManagementDiv;
    /** 運営企画詳細区分. */
    this.vo.planningManagementDetailDiv = this.kymw7200Model.planningManagementDetailDiv;
    /** 商品名. */
    this.vo.goodsName = this.kymw7200Model.goodsName;
    /** 規格名. */
    this.vo.standardName = this.kymw7200Model.standardName;
    // ページ
    this.vo.page = this.kymw7200Model.page;
    this.getOperationGoodsListService.execute(this.kymw7200Model, this.vo, null);
  }

  /**
   * 「次へ」ボタン押下イベント処理
   *
   *  @event イベント
   */
  public eventNext_CLICKHandler(): void {
    // ページ番号をインクリメント(+1)
    this.kymw7200Model.page = (parseInt(this.kymw7200Model.page) + 1).toString();

    /** 宅配業態. */
    this.vo.deliveryDiv = this.kymw7200Model.deliveryDiv;
    /** 注文コード */
    this.vo.orderNum = this.kymw7200Model.orderNum;
    /** 受注企画回*/
    this.vo.orderCatalog = this.kymw7200Model.orderCatalog;
    /** 運営企画区分. */
    this.vo.planningManagementDiv = this.kymw7200Model.planningManagementDiv;
    /** 運営企画詳細区分. */
    this.vo.planningManagementDetailDiv = this.kymw7200Model.planningManagementDetailDiv;
    /** 商品名. */
    this.vo.goodsName = this.kymw7200Model.goodsName;
    /** 規格名. */
    this.vo.standardName = this.kymw7200Model.standardName;
    // ページ
    this.vo.page = this.kymw7200Model.page;
    this.getOperationGoodsListService.execute(this.kymw7200Model, this.vo, null);
  }
  
  /**
   * チェックボックス処理
   *
   * @memberof KYMW7200Component
   */
  public checkBoxEventOperationGoodsMark_CLICKHandler(event: MouseEvent): void {

  }

  /**
   * 削除ボタンイベント
   *
   * @memberof KYMW7200Component
   */
  public eventDeleteOperationGoods_CLICKHandler(grid: FlexGrid): void {

    // 選択されたデータを取得
    const selectedItems = this.kymw7200Model.operationGoodsListData.filter(item => item.targetFlg);
    
    // 一覧項目が１件もチェックされていない場合、エラーとする。
    if (selectedItems.length == 0) {
      this.dialogServiceSub.openAlertGetMessage('E0103', ['運営商品']);
    } else  {
      // 「{0}を削除します。よろしいですか？」
      this.dialogServiceSub.openAlertGetMessage('Q0106', ['運営商品'], (closeEvent: any) => {
        if (closeEvent === PlessAlert.Yes) {
          this.delete();
        }
      });
    }
  }

  /**
   * 「削除」実行
   */
  public delete(): void {
    const grid: FlexGrid = this.dtg_OperationGoodsList;
    this.kymw7200Model.selectedoperationGoodsIds = [];
    grid.rows.forEach(row => {
      if (row.dataItem.targetFlg) {
        this.kymw7200Model.selectedoperationGoodsIds.push(row.dataItem.operationGoodsId);
      }
    });
    this.deleteOperationGoodsListService.execute(this.kymw7200Model.selectedoperationGoodsIds, () => {
      this.deleteSuccess();
    })
  }

  /**
   * 削除完了後処理
   *
   * @param {*} data
   * @memberof KYMW7200Component
   */
  public deleteSuccess(): void {
    //「{0}の削除を完了しました。」
    this.dialogServiceSub.openAlertGetMessage('I0503', ['運営商品'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        this.eventSearchOperationGoods_CLICKHandler();
      }
    });
  }

  /**
   * 新規追加ボタン押下処理
   */
  public eventKYMW7201_CLICKHandler(): void {
    // 検索済の場合検索条件を保持
    if(this.searchFlg) {
      this.router.navigate(['/kymw/7201'], {
        queryParams: {
          // 検索条件
          searchDeliveryDiv: this.kymw7200Model.searchDeliveryDiv,
          searchOrderNum: this.kymw7200Model.searchOrderNum,
          searchPlanningManagementDiv: this.kymw7200Model.searchPlanningManagementDiv,
          searchGoodsName: this.kymw7200Model.searchGoodsName,
          searchOrderCatalog: this.kymw7200Model.searchOrderCatalog,
          searchPlanningManagementDetailDiv: this.kymw7200Model.searchPlanningManagementDetailDiv,
          searchStandardName: this.kymw7200Model.searchStandardName
        },
      });
    } else {
      this.router.navigate(['/kymw/7201']);
    }
    
  }

  /**
   * コンテキストメニュー初期化
   *
   * @memberof KYMW7200Component
   */
  private setContextMenu() {
    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '詳細', cmd: 'operationGoods', enabled: true },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        switch (this.contextMenu.selectedValue) {
          case 'operationGoods':
            this.operationGoodsClickHandler();
            break;
        }
      }
    });
    this.dtg_OperationGoodsList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        this.contextMenuSelectHandler(e);
        // メニュー表示
        this.contextMenu.show(e);
      }
    });
  }

  /**
   * コンテキストメニュー活性制御
   *
   * @memberof KYMW7200Component
   */
  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * コンテキストメニュー 選択
   *
   * @memberof KYMW7200Component
   */
  private contextMenuSelectHandler(e: any): void {
    const ht = this.dtg_OperationGoodsList.hitTest(e.pageX, e.pageY);
    // 右クリック押下時に対象行を選択状態にする
    if (ht.cellType === CellType.Cell) {
      const grid = new CellRange(ht.row, ht.col);
      this.dtg_OperationGoodsList.select(grid, false);
    }
    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode = true;
    // グリッドのセル外または選択行がない場合はコンテキストメニューを非活性
    if (ht.cellType !== CellType.Cell || (PlessViewUtilsSub.isEmptyArray(this.dtg_OperationGoodsList.selectedRows))) {
      contextMenuEnabledMode = false;
      this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
        item.enabled = contextMenuEnabledMode;
      });
    } else {
      this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
        item.enabled = contextMenuEnabledMode;
      });
    }
  }

  /**
   * コンテキストメニュー 詳細 クリック
   *
   * @memberof KYMW7007Component
   */
  private operationGoodsClickHandler() {
    //選択している行の情報を取得
    const selectedRowData = this.kymw7200Model.operationGoodsListData[this.dtg_OperationGoodsList.selection.row];
    this.router.navigate(['/kymw/7201'], {
      queryParams: {
        operationGoodsId: selectedRowData.operationGoodsId,
        // 検索条件
        searchDeliveryDiv: this.kymw7200Model.searchDeliveryDiv,
        searchOrderNum: this.kymw7200Model.searchOrderNum,
        searchPlanningManagementDiv: this.kymw7200Model.searchPlanningManagementDiv,
        searchGoodsName: this.kymw7200Model.searchGoodsName,
        searchOrderCatalog: this.kymw7200Model.searchOrderCatalog,
        searchPlanningManagementDetailDiv: this.kymw7200Model.searchPlanningManagementDetailDiv,
        searchStandardName: this.kymw7200Model.searchStandardName
      },
    });
  }

  /**
   * 運営企画区分チェンジイベント処理
   */
  public cmb_planningManagementDiv_CHANGEHandler(): void {

    //入力項目を活性非活性にする
    this.getPlanningManagementDetailDiv()
  }

  /**
   * 運営企画詳細区分取得する処理
   */
  public getPlanningManagementDetailDiv(): void {
    //運営企画区分の先頭の空白を押した場合
    if (PlessViewUtilsSub.isEmpty(this.kymw7200Model.planningManagementDiv)) {
      this.kymw7200Model.planningManagementDetailDiv = "";
      this.kymw7200Model.setCodeDiv = "";
      return;
    } else {
      // 現在のcodeDivの値を一時的にクリア
      this.kymw7200Model.setCodeDiv = "";

      // 短い遅延を設けてから再度値を設定
      setTimeout(() => {
        this.kymw7200Model.setCodeDiv = "ctp207";
      }, 500);

      //選択した運営企画区分のコード値を整数化した値
      this.kymw7200Model.setReserveNum1 = parseInt(this.kymw7200Model.planningManagementDiv).toString();
      this.kymw7200Model.planningManagementDetailDiv = "";
    }
  }
}
